import type { FeatureGroup } from '../../../../types';
import { ASSETS_FEATURE_GROUP } from '../group';

export const ASSETS_IMAGES_FEATURE_GROUP: FeatureGroup = {
  guid: 'c2f4a8d1-3b70-4e9c-b831-5d2e7f1aff00',
  name: 'assets:images',
  description: 'Image asset features — upload, view, and manage organization images',
  product: 'account',
  parentGuid: ASSETS_FEATURE_GROUP.guid,
};
